// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2DBHr","imageUploader":"EGiftCard_imageUploader__3Xzdd"};